module.exports = __webpack_public_path__ + "img/paraiba-desktop.824e001b.svg";